'use client'

import { useCallback, useState } from 'react'

const REQUIRED_CLICKS = 5
const CLICK_TIMEOUT = 300 // 300ms

export const useVersionDialog = () => {
  const [clickCount, setClickCount] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const [clickTimer, setClickTimer] = useState<NodeJS.Timeout | null>(null)

  const handleRapidClick = useCallback(() => {
    let reachedRequiredClicks = false

    setClickCount((prev) => {
      const newCount = prev + 1

      // Reset timer
      if (clickTimer) {
        clearTimeout(clickTimer)
      }

      // Set new timer to reset count to 1 after 300ms
      const timer = setTimeout(() => {
        setClickCount(0)
      }, CLICK_TIMEOUT)

      setClickTimer(timer)

      // Check if we reached required clicks
      if (newCount >= REQUIRED_CLICKS) {
        setClickCount(0)
        setIsOpen(true)
        if (clickTimer) {
          clearTimeout(clickTimer)
        }
        reachedRequiredClicks = true
      }

      return newCount
    })

    return reachedRequiredClicks
  }, [clickTimer])

  const handleOpenChange = useCallback(
    (open: boolean) => {
      setIsOpen(open)
      setClickCount(0)
      if (clickTimer) {
        clearTimeout(clickTimer)
      }
    },
    [clickTimer]
  )

  return {
    clickCount,
    isOpen,
    handleRapidClick,
    handleOpenChange,
  }
}
